type ScriptConfig = {
  src: string;
  id?: string;
  async?: boolean;
};

export const loadScript = (config: ScriptConfig): Promise<void> => {
  const { id, src, async } = config;

  return new Promise(resolve => {
    const existingScript = id ? document.getElementById(id) : undefined;

    if (!existingScript) {
      const script = document.createElement('script');
      script.src = src;
      script.async = async ? async : false;

      if (id) {
        script.id = id;
      }

      document.body.appendChild(script);

      script.onload = () => {
        resolve();
      };
    } else {
      resolve();
    }
  });
};
